module.exports = "/assets/dist/images/carsaver_at_walmart_logo.png?42da1797eccc6019ee69af04c8b68e31";